import React, { ReactNode, useId } from 'react';

import { LangTag, Req } from '../base';
import * as S from './styles';

interface IProps {
  label?: ReactNode;
  disabled?: boolean | undefined;
  // -- //
  onChange?: (val: any) => void;
  style?: object;
  id?: string;
  error?: boolean;
  success?: boolean;
  message?: string;
  height?: string;
  name?: string;
  onBlur?: (val: object) => void;
  placeholder?: string;
  value?: string;
  /**
   * The design's `.help` — a standing note under the field, as opposed to
   * `message`, which is the validation result. Shown only when there is no
   * message, so a hint never sits under an error saying something else.
   */
  help?: ReactNode;
  labelStyle?: object;
  inputStyle?: object;
  /**
   * Writing direction of the field's own content. 'rtl' also switches the
   * control to --font-ar and right-aligns it, through `ctrlBase`. Set this on
   * the Arabic side of a bilingual pair; the panel's chrome stays LTR.
   */
  dir?: 'ltr' | 'rtl';
  /** Language marker beside the label — the design's `.lang-tag`. */
  langTag?: string;
  /** Renders the design's required asterisk after the label. */
  required?: boolean;
}

const TextArea: React.FC<IProps> = ({
  label,
  id,
  disabled,
  style,
  error,
  success,
  message,
  height,
  onChange,
  name,
  onBlur,
  placeholder,
  labelStyle,
  value,
  inputStyle,
  dir,
  langTag,
  required,
  help
}) => {
  const autoId = useId();

  return (
    <S.inputContainer style={style} className={error ? 'error' : success ? 'success' : ''}>
      <S.label style={labelStyle} className="input-label" htmlFor={id ? id : `${autoId}`}>
        {label}
        {langTag ? <LangTag>{langTag}</LangTag> : <></>}
        {required ? <Req aria-hidden="true">*</Req> : <></>}
      </S.label>
      <S.textarea
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        id={id ? id : `${autoId}`}
        disabled={disabled}
        placeholder={placeholder}
        style={{ ...inputStyle, ...(height ? { height } : {}) }}
        value={value}
        dir={dir}
      />
      {message ? (
        <S.message className={error ? 'error-message' : success ? 'success-message' : ''}>{message}</S.message>
      ) : help ? (
        <S.message>{help}</S.message>
      ) : (
        <></>
      )}
    </S.inputContainer>
  );
};

export default TextArea;
